package com.clany.backoffice.data.repository

import com.clany.backoffice.data.network.KeycloakConfig
import com.clany.backoffice.data.network.NetworkClient
import com.clany.backoffice.domain.repository.InvitationRepository
import com.clany.backoffice.model.InvitationResponse
import io.ktor.client.call.body
import io.ktor.client.request.delete
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.client.request.post
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.ContributesBinding
import com.clany.backoffice.di.AppScope
import dev.zacsweers.metro.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class)
@Inject
class InvitationRepositoryImpl(
    private val networkClient: NetworkClient
) : InvitationRepository {

    private val baseUrl = KeycloakConfig.API_URL

    override suspend fun getInvitations(page: Int, pageSize: Int, query: String?): Result<List<InvitationResponse>> {
        return networkClient.request<List<InvitationResponse>>("$baseUrl/api/invitations") {
            parameter("page", page)
            parameter("limit", pageSize)
            if (query != null) parameter("q", query)
        }
    }

    override suspend fun getInvitationById(id: String): Result<InvitationResponse> {
        return networkClient.request<InvitationResponse>("$baseUrl/api/invitations/$id")
    }

    override suspend fun createInvitation(invitation: InvitationResponse): Result<Unit> {
        return networkClient.request<Unit>("$baseUrl/api/invitations", io.ktor.http.HttpMethod.Post, invitation)
    }

    override suspend fun updateInvitation(id: String, invitation: InvitationResponse): Result<Unit> {
        return networkClient.request<Unit>("$baseUrl/api/invitations/$id", io.ktor.http.HttpMethod.Put, invitation)
    }

    override suspend fun deleteInvitation(id: String): Result<Unit> {
        return networkClient.request<Unit>("$baseUrl/api/invitations/$id", io.ktor.http.HttpMethod.Delete)
    }
}
